import { render } from "./sourcing-event-form.vue?vue&type=template&id=45ebf594&scoped=true"
import script from "./sourcing-event-form.vue?vue&type=script&lang=js"
export * from "./sourcing-event-form.vue?vue&type=script&lang=js"

import "./sourcing-event-form.vue?vue&type=style&index=0&id=45ebf594&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ebf594"]])

export default __exports__